import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import QuestionBoxAdmin from './QuestionBoxAdmin';
import HeaderClient from './HeaderClient';

const QuestionBackEnd = () => {
  return (
    <Container fluid>
      <Row>
        <HeaderClient />
      </Row>
      <Row>
        <Col>
          <QuestionBoxAdmin />
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionBackEnd;
